
    export default {
      path: `/home/runner/work/fase2-website/fase2-website/src/components/pages/ueberuns/fachkompetenz/modal-hsidar.kpa`,
      template: `<div class="modal-hsidar">
        <div class="column">
            <a href="https://cleanodino.de/" target="_blank"><img src="/images/team/cleanodino-logo.png" alt="cleanodino Logo"></a>

            <div class="content">
                <h3>cleanodino</h3>

                <p>
                    Die <a href="https://cleanodino.de/" target="_blank">cleanodino</a> Gebäudereinigung setzt in Leverkusen und Umgebung neue Maßstäbe im Bereich der professionellen Gebäudereinigung. Mit einem Fokus auf nachhaltige Reinigungsprozesse, höchste Hygienestandards und einem Team von hochqualifizierten Reinigungskräften bieten wir erstklassige Dienstleistungen für Privatpersonen und Unternehmen. <a href="https://cleanodino.de/" target="_blank">cleanodino</a> sorgt dafür, dass Ihre Immobilie nicht nur sauber, sondern auch gepflegt und einladend bleibt.
                </p>
            </div>
        </div>

        <hr>

        <div class="column">
            <a href="https://www.der-cleanoshop.de/" target="_blank"><img src="/images/team/der-cleanoshop.jpg" alt="Der Cleanoshop Logo"></a>

            <div class="content">
                <h3>Der Cleanoshop</h3>

                <p>
                    Mit dem "<a href="https://www.der-cleanoshop.de/" target="_blank">Der Cleanoshop</a>" Shop bieten wir Ihnen zudem alles, was Sie für eine professionelle Reinigung benötigen. Ob Reinigungsmittel, Ausrüstungen oder Zubehör – hier finden Sie eine große Auswahl an Produkten, die in der Gebäudereinigung und Sanierung verwendet werden. <a href="https://www.der-cleanoshop.de/" target="_blank">Der Cleanoshop</a> steht für hohe Qualität, Zuverlässigkeit und faire Preise. 
                </p>
            </div>
        </div>
    </div>`,
      style: `modal-hsidar .modal-hsidar {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  gap: 24px;
}
modal-hsidar .modal-hsidar .column {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  gap: 24px;
}
modal-hsidar .modal-hsidar .column img {
  align-self: center;
  width: 250px;
  height: auto;
}
modal-hsidar .modal-hsidar .column h3 {
  text-align: left;
}
modal-hsidar .modal-hsidar .column p {
  text-align: left;
}
@media (max-width: 800px) {
  modal-hsidar .modal-hsidar .column {
    flex-flow: column nowrap;
  }
  modal-hsidar .modal-hsidar .column img {
    align-self: flex-start;
  }
}`,
      script: `(async () => { "use strict";
return {
    data: {},
};
 })()`
    };
  